import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, HorizontalPadding } from '../common/responsive.utils';
interface Main03TitleComponentProps {
    data: Array<boolean>;
    onUpdate: (newData: Array<boolean>) => void;
  }
  
  const MainWeb03TitleComponent : React.FC<Main03TitleComponentProps> = ({ data, onUpdate }) => {
     // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    const onButton = (index: number) => {
        const newValue = [false, false, false];
        newValue[index] = true;
        onUpdate(newValue); // 상위 컴포넌트에 상태 변경 전달
    };

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.webComponent_Web}>

                        <div style={{ height: 88 }} />
                        <div style={styles.webTextContainer01_Web}>
                            <span style={styles.webTitleText_Web} >
                                돌봄 이웃
                            </span>
                        </div>

                        <div style={{ height: 18 }} />

                        <div style={styles.webButtonContainer01_Web}>
                            <div
                                style={(data[0]) ? styles.webSelectButtonTrue_Web : styles.webSelectButtonFalse_Web}
                                onClick={() => onButton(0)}
                            >
                                품앗이 이웃
                            </div>
                            <div
                                style={(data[1]) ? styles.webSelectButtonTrue_Web : styles.webSelectButtonFalse_Web}
                                onClick={() => onButton(1)}
                            >
                                이웃 펫시터
                            </div>
                            <div
                                style={(data[2]) ? styles.webSelectButtonTrue_Web : styles.webSelectButtonFalse_Web}
                                onClick={() => onButton(2)}
                            >
                                펫호텔∙유치원
                            </div>
                        </div>

                        <div style={{ height: 90 }} />
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.component_Mobile} >
                        <div style={{ height: 30 }} />

                        <div style={styles.textContainer01_Mobile}>
                            <span style={styles.titleText_Mobile}>
                                돌봄 이웃
                            </span>
                        </div>

                        <div style={{ height: 18 }} />

                        <div style={styles.buttonContainer01_Mobile} >
                            <div
                                style={(data[0]) ? styles.selectButtonTrue_Mobile : styles.selectButtonFalse_Mobile}
                                onClick={() => onButton(0)}
                            >
                                품앗이 이웃
                            </div>
                            <div
                                style={(data[1]) ? styles.selectButtonTrue_Mobile : styles.selectButtonFalse_Mobile}
                                onClick={() => onButton(1)}
                            >
                                이웃 펫시터
                            </div>
                            <div
                                style={(data[2]) ? styles.selectButtonTrue_Mobile : styles.selectButtonFalse_Mobile}
                                onClick={() => onButton(2)}
                            >
                                펫호텔∙유치원
                            </div>
                        </div>

                        <div style={{ height: 25 }} />
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    webComponent_Web: { width: "100vw", display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },
    webTextContainer01_Web: {display:"flex", flexDirection:"column", justifyContent:"flex-start", alignItems:"flex-start"},
    webTitleText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(22,40), lineHeight:"3.6vw", fontWeight:"700", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0"},
    webButtonContainer01_Web: {display:"flex", flexDirection:"row", justifyContent:"flex-start", boxSizing:"border-box", alignItems:"flex-start", width:"100%", gap:"1.3889vw"},
    webSelectButtonTrue_Web: { paddingTop: responsivePaddingVertical(10, 24), paddingBottom: responsivePaddingVertical(10, 24), paddingLeft: HorizontalPadding(12, 40), paddingRight: HorizontalPadding(12, 40), borderRadius: "2.5vw", border: "0.0556vw solid #9F6BFF", fontFamily: "Pretendard", fontSize: responsiveFont(13, 26), lineHeight:"2.1667vw", fontWeight:"600", letterSpacing:"-0.02em", textAlign:"center", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", color:"#9F6BFF", backgroundColor:"white"},
    webSelectButtonFalse_Web: { paddingTop: responsivePaddingVertical(10, 24), paddingBottom: responsivePaddingVertical(10, 24), paddingLeft: HorizontalPadding(12, 40), paddingRight: HorizontalPadding(12, 40), borderRadius: "2.5vw", border: "0.0556vw solid #E8E8E9", fontFamily: "Pretendard", fontSize: responsiveFont(13, 26), lineHeight:"2.1667vw", fontWeight:"600", letterSpacing:"-0.02em", textAlign:"center", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", color:"#454A50", backgroundColor:"white"},

    component_Mobile: { width: "100%", minWidth:"320px", display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "flex-start", justifyContent: 'flex-start' },
    textContainer01_Mobile: { display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingLeft: HorizontalPadding(24, 88), paddingRight: HorizontalPadding(24, 88) },
    titleText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight: "9.62vw", fontWeight: "700", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none" },
    buttonContainer01_Mobile: { display: "flex", flexDirection: "row", justifyContent: "space-between", boxSizing: "border-box", alignItems: 'flex-start', paddingLeft: HorizontalPadding(24, 88), paddingRight: HorizontalPadding(24, 88), width: "100%" },
    selectButtonTrue_Mobile: { paddingTop: responsivePaddingVertical(10, 24), paddingBottom: responsivePaddingVertical(10, 24), paddingLeft: HorizontalPadding(12, 40), paddingRight: HorizontalPadding(12, 40), borderRadius: "36px", border: "0.8px solid #9F6BFF", fontFamily: "Pretendard", fontSize: responsiveFont(13, 26), fontWeight: "600", lineHeight: "4.87vw", letterSpacing: "-0.02em", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#9F6BFF", backgroundColor: "white" },
    selectButtonFalse_Mobile: { paddingTop: responsivePaddingVertical(10, 24), paddingBottom: responsivePaddingVertical(10, 24), paddingLeft: HorizontalPadding(12, 40), paddingRight: HorizontalPadding(12, 40), borderRadius: "36px", border: "0.8px solid #E8E8E9", fontFamily: "Pretendard", fontSize: responsiveFont(13, 26), fontWeight: "600", lineHeight: "4.87vw", letterSpacing: "-0.02em", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#454A50", backgroundColor: "white" },
});

export default MainWeb03TitleComponent